import React, { useEffect, useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';

import { useStyles } from './styles';
import { calculateAverage } from '../../../utils/helper';

interface Row {
  label: string;
  value: number | string;
}

interface IFilterItem {
  type: 'effective_sizing' | 'relevance_analysis';
  data: any;
  checked?: boolean;
  onChange?: (name: string, active: boolean) => void;
}

const FilterItem: React.FC<IFilterItem> = ({ type, data }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [rows, setRows] = useState<Row[]>([]);

  useEffect(() => {
    if (type === 'effective_sizing') {
      setRows([
        {
          label: t('screens:dimensioning.hourmeter'),
          value: `${data.hourmeter}h`,
        },
        {
          label: t('screens:dimensioning.physicalAvailability'),
          value:
            data.physical_availability.length > 0
              ? `${calculateAverage(data.physical_availability).toFixed(1)}%`
              : '-',
        },
        {
          label: 'MTBF',
          value: data.mtbf !== -1 ? `${data.mtbf.toFixed(1)}h` : '-',
        },
      ]);
    } else {
      setRows([
        {
          label: t('screens:dimensioning.hourmeter'),
          value: `${data.hourmeter}h`,
        },
        {
          label: t('screens:dimensioning.physicalAvailability'),
          value: `${data.average_df.toFixed(1)}%`,
        },
        {
          label: 'MTBF',
          value:
            data.average_mtbf !== -1 ? `${data.average_mtbf.toFixed(1)}h` : '-',
        },
      ]);
    }
  }, [type, data, t]);

  return (
    <Accordion className={classes.container}>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-label={t('screens:dimensioning.expandFilterAria')}
        aria-controls={t('screens:dimensioning.expandFilterAriaControls')}
        id="additional-actions1-header"
      >
        <div className={classes.description}>
          <Typography className={classes.model} variant="subtitle1">
            {data.name.toUpperCase()}
          </Typography>
          <Typography className={classes.brand} variant="subtitle1">
            {data.brand.toUpperCase()}
          </Typography>
        </div>
        {/* <FormControlLabel
          aria-label={t('screens:dimensioning.description')}
          onClick={event => event.stopPropagation()}
          onFocus={event => event.stopPropagation()}
          label={
            <div className={classes.description}>
              <Typography className={classes.model} variant="subtitle1">
                {data.name.toUpperCase()}
              </Typography>
              <Typography className={classes.brand} variant="subtitle1">
                {data.brand.toUpperCase()}
              </Typography>
            </div>
          }
        /> */}
      </AccordionSummary>

      <AccordionDetails>
        <TableContainer>
          <Table
            size="small"
            aria-label={t('screens:dimensioning.drillInfoTableAria')}
            className={classes.table}
          >
            <TableBody>
              {rows.map(row => (
                <TableRow key={row.label}>
                  <TableCell
                    component="th"
                    scope="row"
                    className={classes.cell}
                  >
                    {row.label}
                  </TableCell>
                  <TableCell align="right" className={classes.cell}>
                    {row.value}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </AccordionDetails>
    </Accordion>
  );
};

export default FilterItem;
